import {
  Button,
  ButtonEmpty,
  FormRow,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalHeaderTitle,
  Text,
  TextArea,
} from '@antoree/ant-ui';
import { useEffect, useState } from 'react';
import { useToggle } from 'hooks';
import { useCurrentUser } from 'contexts';
import { Session } from 'services/session';

import { AvailableTime, SlotTimeSelectedType } from 'configs/types';
import { useRetrieveAvailableTime } from 'services/reschedule';
import moment from 'moment';
import { AVAILABLE_TIME_TYPE } from 'containers/Schedule/types';
import BookingModal from './components';
import { generateSchedule } from './components/utils';
import { BACK, FORWARD } from './components/constant';

export type AbsenceReasonModalProps = {
  close: () => void;
  onConfirmAbsent: (
    absenceReason: string,
    schedules?: SlotTimeSelectedType[],
  ) => void;
  isLoading: boolean;
  session: Session;
};

const AbsenceReasonModal: React.FC<AbsenceReasonModalProps> = ({
  close,
  onConfirmAbsent,
  isLoading,
  session,
}) => {
  const [absenceReason, setAbsenceReason] = useState<string>();
  const [date, setDate] = useState({
    startedAt: moment(session?.occurredAt).startOf('isoWeek'),
    endedAt: moment(session?.occurredAt).endOf('isoWeek'),
  });
  const { id } = useCurrentUser();
  const [isRequired, setRequired] = useState(false);
  const {
    close: closeBookingModal,
    isVisiable: isVisibleBookingModal,
    open: onOpenBookingModal,
  } = useToggle();

  const {
    data,

    isLoading: isLoadingAvailableTime,
  } = useRetrieveAvailableTime(
    {
      teacherId: id,
      startedAt: date.startedAt.format('YYYY-MM-DD 00:00:01'),
      endedAt: date.endedAt.format('YYYY-MM-DD 59:59:01'),
    },
    {
      enabled: isVisibleBookingModal,
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  );
  const handleChangeDate = (step: string) => {
    if (step === FORWARD) {
      setDate(prev => ({
        startedAt: moment(prev.startedAt).add(7, 'days'),
        endedAt: moment(prev.endedAt).add(7, 'days'),
      }));
    }
    if (step === BACK) {
      setDate(prev => ({
        startedAt: moment(prev.startedAt).subtract(7, 'days'),
        endedAt: moment(prev.endedAt).subtract(7, 'days'),
      }));
    }
  };
  const handleConfirm = () => {
    if (absenceReason) onConfirmAbsent(absenceReason);
  };

  return (
    <>
      {/* {isVisibleBookingModal && data?.data.availableTimes && (
        <BookingModal
          isLoadingAvailableTime={isLoadingAvailableTime}
          onClose={close}
          teacherAvailableTime={data?.data.availableTimes}
          handleConfirmAbsence={handleConfirm}
          isLoadingConfirmAbsence={isLoading}
          date={date}
          handleChangeDate={handleChangeDate}
          occurredAt={session.occurredAt}
        />
      )} */}
      <Modal onClose={close}>
        <ModalHeader>
          <ModalHeaderTitle>
            <h1>Submit Absent Leave</h1>
          </ModalHeaderTitle>
        </ModalHeader>

        <ModalBody>
          <Text className="font-semibold text-lg">
            Regulations on absences.
          </Text>
          <Text className="font-semibold text-xs text-danger">
            PLEASE WRITE THE CORRECT REASON FOR LEAVING BECAUSE THIS REPORT WILL
            BE SENT STRAIGHT TO STUDENT.
          </Text>

          <FormRow
            fullWidth
            label="Reason"
            required
            isInvalid={isRequired}
            error="Required"
            className="mt-4"
          >
            <TextArea
              fullWidth
              placeholder="Enter your reason"
              aria-label="Absence reason"
              onChange={e => {
                setAbsenceReason(e.target.value);
                if (e.target.value) {
                  setRequired(false);
                } else setRequired(true);
              }}
              maxLength={100}
            />
          </FormRow>
          <Text color="red" size="xs">
            Please enter a reason less than 100 characters
          </Text>
          <span style={{ color: '#69707D' }}>
            Help your student know the details.
          </span>
        </ModalBody>

        <ModalFooter>
          <Button
            fill
            fullWidth
            onClick={() => handleConfirm()}
            isLoading={isLoading}
          >
            Submit
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AbsenceReasonModal;
